import { cloneDeep } from 'lodash-es';

/**
 * @internal
 */
export function format(first: string, middle: string, last: string): string {
  return (first || '') + (middle ? ` ${middle}` : '') + (last ? ` ${last}` : '');
}

/**
 * @internal
 */
export function getRootAttribute(attributeName: string): string {
  return document.documentElement?.getAttribute(attributeName);
}

/**
 * @internal
 */
export function setRootAttribute<T extends string, U extends string>(attributeName: T, attributeValue: U) {
  if (document != null) {
    const root = document.documentElement;
    root.setAttribute(attributeName, attributeValue);
  }
}

/**
 * @internal
 */
export function removeRootAttribute(attributeName: string) {
  if (document != null) {
    const root = document.documentElement;
    root.removeAttribute(attributeName);
  }
}

/**
 * @internal
 */
export function observeRootChange(attributeName: string, mutationsList: Array<MutationRecord>): string {
  for (const mutation of mutationsList) {
    if (mutation.attributeName === attributeName) {
      return document.documentElement?.getAttribute(attributeName);
    }
  }
  return null;
}

/**
 * @internal
 */
export function parseStringOrObject(value: string | unknown): any {
  if (typeof value === 'string') {
    return JSON.parse(value);
  }

  return value;
}

/**
 * Generate a random alphanumeric itemId. Default length is 6.
 * @internal
 * @returns {string} Return the ID.
 * @example "yyaroo6"
 */
export function alphanumericId(length: number = 6): string {
  let id = '';
  while (id.length < length) {
    id += Math.random().toString(36).substring(2);
  }
  return id.substring(0, length);
}

/**
 * Log the state of a component.
 * @param name
 * @param state
 * @param source
 * @param key
 */
export function dumpComponentState(name: string, state: object = null, source = '', key = ''): void {
  const _key = key.length > 0 ? '-' + key : '';
  const ext = _key + (source.length > 0 ? `[${source}]:` : ':');
  const label = name + ext;
  const clonedState = cloneDeep(state);
  if (state != null) console.log(label, clonedState);
  else console.log(label);
}
